"use client";

import { StockMovementStepper } from "../components/stockMovement/StockMovementStepper";

export default function StockMovementPage() {
  return (
    <div className="min-h-screen bg-background p-8">
      <div className="mx-auto max-w-4xl">
        <div className="mb-8">
          <h1 className="text-3xl font-bold">Stock Movement</h1>
          <p className="text-muted-foreground mt-2">
            Record a stock movement
          </p>
        </div>
        <StockMovementStepper />
      </div>
    </div>
  );
}